
<!--订单详情块 左右布局-->
<template>
    <div class="chunk" :style="{'align-items': vertical}">
        <div class="chunk-left" :class="{wid56: wid56}">{{title}}</div>
        <div class="chunk-right" :class="{'van-ellipsis': limit}">
            <slot name="context">{{desc}}</slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Chunk',
        props: {
            title: String,
            desc: String,
            limit: Boolean,
            vertical: {
                type: String,
                default: 'center'
            },
            wid56: Boolean,
            leftClass: Object,
        },
    }
</script>

<style lang="scss" scoped>
    .chunk {
        padding: 15px 0;
        display: flex;
        &-left {
            font-size: 14px;
            color: rgba(105, 112, 127, 1);
            margin-right: 13px;
            flex-shrink: 0;
        }
        &-right {
            flex: 1;
            font-size: 15px;
            font-weight: 400;
            color: rgba(34, 34, 34, 1);
        }

        .wid56 {
            width: 56px;
        }
    }
</style>
